import { store } from '@/app/store'

/**
 * Authentication guard.
 * 
 * @param  {?} to
 * @param  {?} from
 * @param  {?} next
 * @return {void}
 */
export function AuthenticationGuard(to, from, next) {
  if (!window.$cookies.get(process.env.AUTH_COOKIE_NAME))
    next({
      name: 'AuthenticationLogin',
      query: {url: to.path}
    })
  else
    next()
}

/**
 * Guest guard.
 * 
 * @param  {?} to
 * @param  {?} from
 * @param  {?} next
 * @return {void}
 */
export function GuestGuard(to, from, next) {
  if (window.$cookies.get(process.env.AUTH_COOKIE_NAME))
    next({
      name: process.env.HOME_PATH_NAME
    })
  else
    next()
}



// WEBPACK FOOTER //
// ./src/app/authentication/authentication.guard.js